import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../../../libs/css/date-picker.css';
import LoadingSpinnerSmall from '../LoadingSpinner/LoadingSpinnerSmall';
import { API_ROUTES } from '../../../utils/constants';

const formatDateYMD = (date) => {
    if (!date) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const HourlyRevenueFilter = ({ onSubmit, isLoading, isAuthExpired }) => {
    const today = new Date();
    const [selectedDate, setSelectedDate] = useState(today);
    const [networkId, setNetworkId] = useState('');
    const [serviceId, setServiceId] = useState('');
    const [operatorList, setOperatorList] = useState([]);
    const [distinctList, setDistinctList] = useState([]);
    const [loadingLists, setLoadingLists] = useState(true);
    const [error, setError] = useState('');

    const userData = JSON.parse(localStorage.getItem('userDataFs'));

    const filteredServiceList = networkId
        ? distinctList.filter((s) => String(s.network_id) === String(networkId))
        : distinctList;

    useEffect(() => {
        const fetchLists = async () => {
            setLoadingLists(true);
            try {
                const [opResponse, svcResponse] = await Promise.all([
                    fetch(API_ROUTES.OPERATORS, {
                        method: 'POST',
                        headers: { token: userData?.responseDetails?.token },
                    }),
                    fetch(API_ROUTES.DISTINCT_SERVICES, {
                        method: 'POST',
                        headers: { token: userData?.responseDetails?.token },
                    }),
                ]);
                const opJSON = await opResponse.json();
                const svcJSON = await svcResponse.json();
                isAuthExpired(opJSON);
                if (opJSON.status.toString() === '200') setOperatorList(opJSON.data);
                if (svcJSON.status.toString() === '200') setDistinctList(svcJSON.data);
            } catch (e) {
                console.log('Error fetching filter lists:', e);
            } finally {
                setLoadingLists(false);
            }
        };
        fetchLists();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleNetworkChange = (e) => {
        setNetworkId(e.target.value);
        setServiceId('');
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!selectedDate) { setError('Date is required'); return; }
        setError('');
        onSubmit({
            date: formatDateYMD(selectedDate),
            network_id: networkId || '',
            serviceId: serviceId || '',
        });
    };

    return (
        <div className="card mb-4 mt-25 p-5">
            <form onSubmit={handleSubmit} className="row g-3 align-items-end" aria-label="Hourly summary filters">
                <div className="col-md-3">
                    <DatePicker
                        selected={selectedDate}
                        className="filter_text"
                        onChange={(date) => { setSelectedDate(date); setError(''); }}
                        dateFormat="yyyy-MM-dd"
                        maxDate={today}
                        isClearable={false}
                        placeholderText="Select date"
                        calendarClassName="large-calendar"
                        aria-label="Report date"
                    />
                </div>

                <div className="col-md-3">
                    <select className="filter_text" value={networkId} onChange={handleNetworkChange} aria-label="Filter by network">
                        <option value="">-Network (All)-</option>
                        {operatorList.map((operator, index) => (
                            <option key={`${operator.id}${index}`} value={operator.id}>{operator.network}</option>
                        ))}
                    </select>
                </div>

                <div className="col-md-3">
                    {loadingLists && <LoadingSpinnerSmall />}
                    <select
                        className="filter_text"
                        value={serviceId}
                        onChange={(e) => setServiceId(e.target.value)}
                        disabled={loadingLists}
                        style={{ opacity: loadingLists ? 0.4 : 1 }}
                        aria-label="Filter by service"
                    >
                        <option value="">-Service (All)-</option>
                        {filteredServiceList.map((item, index) => (
                            <option key={`${item.serviceId}${index}`} value={item.serviceId}>{item.serviceName}</option>
                        ))}
                    </select>
                </div>

                <div className="col-md-3">
                    <button type="submit" className="btn_1 btn-primary w-100" disabled={isLoading} aria-label="Apply filters" style={{ opacity: isLoading ? 0.5 : 1, marginBottom: '15px' }}>
                        {isLoading ? 'Loading...' : <><i className="fa fa-search"></i> Filter</>}
                    </button>
                </div>

                {error && (
                    <div className="col-12 mt-2">
                        <div className="alert alert-danger" role="alert">{error}</div>
                    </div>
                )}
            </form>
        </div>
    );
};

export default HourlyRevenueFilter;
